<template>
    <div class="my-surveys">
        <div class="card card-default card-reviews">
            <div class="card-header border-bottom align-items-center">
                <span class="header-title">{{ __('My Widgets') }}</span>
                <a href="/social/widget/new" class="text-center btn btn-primary pull-right">NEW WIDGET</a>
            </div>
            <div class="card-body" :class="{'loading': loading, 'p-0': !loading && widgets.length === 0}">
                <div class="loader">
                    <i class="fas fa-circle-notch fa-spin"></i> Loading widgets...
                </div>
                <div id="instagram-widgets">
                    <div v-for="widget in widgets" class="guestflip-item-wrapper">
                        <div class="row guestflip-item mx-0">
                            <div class="col-md-4 pl-3">
                                <div class="profile align-items-center">
                                    <div class="left">

                                    </div>
                                    <div class="right">
                                        <p class="blue-text">
                                            <strong>
                                                {{ widget.title }}
                                            </strong>
                                        </p>
                                        <p>
                                            <a v-bind:href="'/social/widget/' + widget.id"
                                               class="blue-link mr-2">
                                                <i class="far fa-edit"></i>EDIT
                                            </a>
                                            <a :href="getPreviewUrl(widget.id)"
                                               target="_blank"
                                               class="blue-link mr-2">
                                                <i class="fas fa-search"></i>PREVIEW
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-8">
                                <div class="metrics row">
                                    <div class="col-md-3 metric-wrapper border-right">
                                        <p class="metric-label"><strong>{{ __('Views') }}</strong></p>
                                        <p class="metric-number">{{widget.stats ? widget.stats.pageView : 'N/A'}}</p>
                                    </div>
                                    <div class="col-md-3 metric-wrapper border-right">
                                        <p class="metric-label"><strong>{{ __('Unique Views') }}</strong></p>
                                        <p class="metric-number">{{widget.stats ? widget.stats.pageVisit : 'N/A'}}</p>
                                    </div>
                                    <div class="col-md-3 metric-wrapper border-right">
                                        <p class="metric-label"><strong>{{ __('Clicks') }}</strong></p>
                                        <p class="metric-number">{{widget.stats ? widget.stats.postClick : 'N/A'}}</p>
                                    </div>
                                    <div class="col-md-3 metric-wrapper">
                                        <p class="metric-label"><strong>{{ __('Actions Performed') }}</strong></p>
                                        <p class="metric-number">{{widget.stats ? widget.stats.actionPerformed : 'N/A'}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            @click="getEmbedInstructions(widget)"
                            target="_blank"
                            class="embed-instructions-button blue-link mr-2">
                            <i class="fas fa-paper-plane"></i> GET EMBED INSTRUCTIONS
                        </div>
                    </div>
                </div>
                <div class="overflow-hidden" v-if="!loading && widgets.length === 0">
                    <h5 class="header-case mt-3 text-center">
                        Introducing: Instagram Widgets!
                    </h5>
                    <p class="thin-title text-center">You can use GuestFlip's Instagram Widgets to promote the best user-generated content on your website. Boost your online conversions by showcasing the best content from happy guests.</p>
                    <p class="text-center">
                        <a href="/social/widget/new" class="btn btn-primary">CREATE MY FIRST WIDGET</a>
                    </p>
                    <p class="text-center">
                        <a :href="sampleUrl" class="blue-link" target="_blank"><i class="fas fa-eye"></i> See how it works on a sample website.</a>
                    </p>
                    <img src="/assets/img/bg-one.png" class="w-100" alt="Onboarding"/>
                </div>
            </div>
        </div>
        <div class="modal" ref="embed_instructions_modal">
            <div class="modal-dialog gf full-width">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">WIDGET EMBED INSTRUCTIONS FOR WIDGET {{selectedWidget.title}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="first-step">
                            <div class="widget-embed-step-header mb-3">
                                Step 1
                            </div>
                            <div classs="mb-4">
                                <div class="mb-2">
                                    Add the following script directly in your site <span class="error">( if you have already added the script for the reputation widget, skip this step )</span> :
                                </div>
                                <code class="widget-code">
                                    &lt;script src=&quot;https://d2la9d5c60fe5e.cloudfront.net/loader.js&quot;&gt;&lt;/script&gt;
                                </code>
                            </div>
                        </div>
                        <div class="step-two mt-4">
                            <div class="widget-embed-step-header mb-3">
                                Step 2
                            </div>
                            <div class="mb-4">
                                <div class="mb-2">
                                    In every place you want your widget to be visible, insert the following code:
                                </div>
                                <code class="widget-code">
                                    &lt;div data-guestflip="instagram" data-guestflip-widget-id="{{selectedWidget.id}}"&gt&lt;/div&gt
                                </code>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .widget-embed-step-header {
        font-weight: bold;
        font-size: 17px;
    }
    .embed-instructions-button {
        position: absolute;
        left: 15px;
        bottom: 15px;
        cursor: pointer;
        color: #00aef1;
    }
</style>
<script>
    import InstagramService from '../../services/instagram-service'

    export default {
        data: function() {
            return {
                selectedWidget: {},
                loading: false,
                widgets: []
            }
        },
        computed: {
            sampleUrl() {
                return process.env.MIX_PAGES_URL + '/widget/4?teamId=0#next'
            }
        },
        methods: {
            getPreviewUrl(id) {
                // return '/widget/preview/' + id + '?teamId=' + Spark.state.currentTeam.id + '#next'
                return process.env.MIX_PAGES_URL + '/widget/' + id + '?teamId=' + Spark.state.currentTeam.id + '#next'
            },
            getEmbedInstructions(widget) {
                this.selectedWidget = widget
                $(this.$refs.embed_instructions_modal).modal('toggle')
            }
        },
        async mounted() {
            this.loading = true

            const widgets = await InstagramService.v2.widgets.index()
            this.widgets = widgets.data

            this.loading = false
        }
    }
</script>
